import { createContext } from 'react'

export const ScrollRefContext =
  createContext<React.RefObject<HTMLElement> | null>(null)
